
import { LabelFilter } from '@/model';
import { getLabelTypeOrder } from '@/store/labels';
import Vue from 'vue';

export default Vue.extend({
  name: 'LabelFilterEditor',

  props: {
    value: { type: Object as () => LabelFilter | undefined },
  },

  data() {
    return {
      editFilter: { ...this.value } as LabelFilter,
    };
  },

  computed: {
    labelTypeOptions(): string[] {
      return getLabelTypeOrder();
    },
  },

  watch: {
    value: {
      handler(v: LabelFilter) {
        this.editFilter = { ...v };
      },
      immediate: true,
    },
  },

  methods: {
    input() {
      this.$emit('input', this.editFilter);
    },
    changeFilter(key: keyof LabelFilter, value: LabelFilter[typeof key]) {
      this.editFilter = { ...this.editFilter, [key]: value };
      this.input();
    },
    reset() {
      this.editFilter = {};
      this.input();
    },
  },
});
